(function () {
	let headerLogoScrollHandler = null;
	let headerLogoResizeHandler = null;

	const initHeaderLogoScroll = () => {
		const wrapper = document.querySelector(
			".header-wrapper[data-dual-logo], .header-wrapper[data-has-sticky-logo]",
		);
		if (headerLogoScrollHandler) {
			window.removeEventListener("scroll", headerLogoScrollHandler);
			headerLogoScrollHandler = null;
		}
		if (headerLogoResizeHandler) {
			window.removeEventListener("resize", headerLogoResizeHandler);
			headerLogoResizeHandler = null;
		}
		if (!wrapper) return;

		const headerEl = document.querySelector(".shopify-section-header .header");
		if (!headerEl) return;

		/** Half header height — fixed at measure time so logo swaps do not change the threshold */
		let baseHalfHeight = Math.max(1, Math.round(headerEl.offsetHeight / 2));
		const HYSTERESIS_PX = 16;
		let isScrolled = false;

		const runScrollUpdate = () => {
			const y = window.scrollY;
			const enter = baseHalfHeight + HYSTERESIS_PX;
			const exit = Math.max(0, baseHalfHeight - HYSTERESIS_PX);

			if (!isScrolled && y > enter) {
				isScrolled = true;
			} else if (isScrolled && y < exit) {
				isScrolled = false;
			}

			wrapper.classList.toggle("header-wrapper--scrolled", isScrolled);
		};

		const recalcBaseHeight = () => {
			baseHalfHeight = Math.max(1, Math.round(headerEl.offsetHeight / 2));
			const y = window.scrollY;
			isScrolled = y > baseHalfHeight;
			wrapper.classList.toggle("header-wrapper--scrolled", isScrolled);
		};

		let ticking = false;
		headerLogoScrollHandler = () => {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(() => {
				runScrollUpdate();
				ticking = false;
			});
		};

		headerLogoResizeHandler = () => {
			recalcBaseHeight();
		};

		window.addEventListener("scroll", headerLogoScrollHandler, { passive: true });
		window.addEventListener("resize", headerLogoResizeHandler, { passive: true });
		runScrollUpdate();
	};

	const header = () => {
		const body = document.querySelector("body");
		const openBtn = document.querySelector(".header__offcanvas-toggle");
		const closeBtn = document.querySelector(
			".header__offcanvas-toggle-link--close",
		);
		const offMenu = document.querySelector(".header__offcanvas-menu");
		const searchDetails = document.querySelector(".header__details");
		const openSearchBtn = document.querySelector(".header__search");
		const searchModal = document.querySelector(".search-modal");
		const submenuDetails = document.querySelectorAll(
			".header__submenu li details",
		);

		const openMenu = (e) => {
			e.preventDefault();
			offMenu.classList.add("header__offcanvas-menu--open");
			openBtn.classList.add("active");
			body.classList.add("body--hidden");
		};

		const closeMenu = () => {
			offMenu.classList.remove("header__offcanvas-menu--open");
			openBtn.classList.remove("active");
			body.classList.remove("body--hidden");
		};

		openBtn.addEventListener("click", openMenu);
		closeBtn.addEventListener("click", closeMenu);

		openSearchBtn.addEventListener("click", (e) => {
			if (searchDetails.open) {
				body.classList.add("body--hidden");
				setTimeout(() => {
					searchModal.classList.add("search-modal--overflow");
				}, 1000);
			} else {
				body.classList.remove("body--hidden");
				searchModal.classList.remove("search-modal--overflow");
			}
		});

		submenuDetails.forEach((targetDetail) => {
			targetDetail.addEventListener("click", () => {
				submenuDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute("open");
					}
				});
			});
		});

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				closeMenu();
				searchDetails.removeAttribute("open");
			}
		});

		initHeaderLogoScroll();
	};

	document.addEventListener("shopify:section:load", header);

	header();
})();
